module.exports = __webpack_public_path__ + "front/img/q1.badc27df.png";